import { Link } from "react-router-dom";
import "../../App.css";
import Footer from "../Footer";
import Reveal from "../Reveal";
import Seo from "../Seo";
import "./Prijslijst.css";

const HIGHLIGHTS = [
    {
        title: "LED Cijfers & Letters",
        from: "€29,95",
        per: "per stuk",
        route: "/producten/cijfers_en_letters",
    },
    {
        title: "Verlichting",
        from: "€14,95",
        per: "per stuk",
        route: "/producten/verlichting",
    },
    {
        title: "Photobooth",
        from: "€329,95",
        per: "per circa 4 uur",
        route: "/producten/photobooth",
    },
    {
        title: "LED-Dansvloer",
        from: "€379,95",
        per: "per evenement",
        route: "/producten/dansvloer",
    },
];

function Prijslijst() {
    return (
        <>
            <Seo
                title="Prijslijst"
                description="Transparante huurprijzen voor al onze feestdecoratie — van lichtgevende cijfers vanaf €29,95 tot de LED-dansvloer."
                path="/prijslijst"
            />
            <section className="prijslijst-hero">
                <div className="prijslijst-hero-content">
                    <span className="prijslijst-eyebrow">PRIJSLIJST</span>
                    <h1 className="prijslijst-title">Onze tarieven</h1>
                    <div className="prijslijst-rule" aria-hidden="true"></div>
                    <p className="prijslijst-subtitle">
                        Een overzicht van onze meest gevraagde categorieën,
                        gevolgd door de volledige prijslijst.
                    </p>
                </div>
            </section>

            <Reveal as="section" className="prijslijst-highlights reveal--stagger">
                <div className="prijslijst-highlight-grid">
                    {HIGHLIGHTS.map((h, i) => (
                        <Link
                            key={h.route}
                            to={h.route}
                            className="prijslijst-highlight-card stagger-item"
                            style={{ "--stagger-index": i }}>
                            <span className="prijslijst-highlight-eyebrow">
                                Vanaf
                            </span>
                            <span className="prijslijst-highlight-price">
                                {h.from}
                            </span>
                            <span className="prijslijst-highlight-per">
                                {h.per}
                            </span>
                            <div
                                className="prijslijst-highlight-rule"
                                aria-hidden="true"></div>
                            <span className="prijslijst-highlight-title">
                                {h.title}
                            </span>
                            <span className="prijslijst-highlight-arrow">
                                Bekijk{" "}
                                <span className="prijslijst-highlight-arrow-mark">
                                    →
                                </span>
                            </span>
                        </Link>
                    ))}
                </div>
            </Reveal>

            <Reveal as="section" className="prijslijst-image-section">
                <div className="prijslijst-image-header">
                    <span className="prijslijst-eyebrow">VOLLEDIG OVERZICHT</span>
                    <h2 className="prijslijst-image-title">
                        Alle tarieven in één oogopslag
                    </h2>
                </div>

                <div className="prijslijst-image-grid">
                    <div className="prijslijst-image-frame">
                        <img
                            src={
                                process.env.PUBLIC_URL +
                                "/images-v2/prijslijst/1.webp"
                            }
                            alt="Prijslijst Van Vlimmeren Feestverhuur — losse artikelen"
                            loading="lazy"
                            className="prijslijst-image"
                        />
                    </div>
                    <div className="prijslijst-image-frame">
                        <img
                            src={
                                process.env.PUBLIC_URL +
                                "/images-v2/prijslijst/2.webp"
                            }
                            alt="Prijslijst Van Vlimmeren Feestverhuur — pakketten"
                            loading="lazy"
                            className="prijslijst-image"
                        />
                    </div>
                </div>

                <div className="prijslijst-download">
                    <a
                        href={process.env.PUBLIC_URL + "/prijslijst.pdf"}
                        download
                        className="btn btn--primary btn--lg">
                        Download Prijslijst (PDF)
                    </a>
                </div>
            </Reveal>

            <Reveal as="section" className="prijslijst-cta">
                <div className="prijslijst-cta-inner">
                    <span className="prijslijst-cta-eyebrow">AANVRAAG</span>
                    <h2 className="prijslijst-cta-title">Uw feest begint hier</h2>
                    <p className="prijslijst-cta-text">
                        Stel uw aanvraag samen — wij nemen binnen 24 uur contact
                        met u op.
                    </p>
                    <Link
                        to="/aanvraag"
                        className="btn btn--primary btn--on-dark btn--lg">
                        Start uw aanvraag
                    </Link>
                </div>
            </Reveal>

            <Footer />
        </>
    );
}

export default Prijslijst;
